import React, { Component, } from "react";
import Slider from "react-slick";
import certFE from "../sources/html_css_js.jpg";
import certJS from "../sources/JS.jpg";
import vid1 from "../sources/go-surf.mp4";
import vid2 from "../sources/belcop.mp4";
import vid3 from "../sources/layout.mp4";
import vid4 from "../sources/texode.mp4";
import vid5 from "../sources/weather-app.mp4";
import vid6 from "../sources/wtg.webm";
import vid7 from "../sources/audiocomplex.webm";
import vid8 from "../sources/aboutad.webm";
import vid9 from "../sources/breaking-com-pl.webm";
import vid10 from "../sources/equilibra.webm";
import vid11 from "../sources/giardDesign.webm";

export default class SimpleSlider extends Component {
  constructor(props) {
    super(props);
    this.state = { isModal: false, video: "", cardId: 0 };
    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    this.setState((prevState) => ({
      isModal: true,
      video: e.target.src,
      cardId: e.target.id,
    }));
  }

  render() {
    const settings = {
      dots: false,
      fade: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const video = [
      { src: vid6, git: 'https://waytogrow.com/' },
      { src: vid7, git: 'https://audiocomplex.pl/' },
      { src: vid8, git: 'https://aboutad.pl/' },
      { src: vid5, git: 'https://ilya-nahorny.github.io/weather/' },
      { src: vid1, git: 'https://ilya-nahorny.github.io/go-surf/' },
      { src: vid3, git: 'https://ilya-nahorny.github.io/layoutResponsive/' },
      { src: vid9, git: 'https://breaking.com.pl/' },
      { src: vid10, git: 'https://equilibrasklep.pl/p/oczyszczajaca-odzywka-z-aktywnym-weglem-200ml' },
      { src: vid11, git: 'https://ilya-nahorny.github.io/' },

      // { src: vid4, git: 'https://ilya-nahorny.github.io/TexodeTestLanding/' },
      // { src: vid2, git: 'https://ilya-nahorny.github.io/BelCopGame' },

    ];
    return (
      <div className="slider-case animate__animated animate__fadeInRight">

        <span className="background_text">{this.props.case.certificates.title}</span>

        <Slider {...settings}>
          <div className="slide">
            <h3 className="title">{this.props.case.exp.title}</h3>
            <div className="examples">
              {video.map((arr, ind) => {
                return (
                    <a className="card" onClick={this.handleClick} href={video[ind].git} alt={video[ind].git}>
                      <span className="card_link" >git</span>
                      <video
                          src={video[ind].src}
                          width={500}
                          height={300}
                          muted
                          autoPlay
                          loop
                      ></video>
                    </a>
                );
              })}
            </div>
          </div>

          <div className="slide">
            <h3 className="title">{this.props.case.certificates.title}</h3>
            <div className="certificates">
              <div className="cert cert-FE">
                <a href={certFE}><img src={certFE}></img></a>
                <p>
                  {this.props.case.certificates.descrFE}
                  <br />
                  <span>
                    {this.props.case.certificates.school}
                    <br />
                    (04.2019 - 7.2019)
                  </span>
                </p>
              </div>
              <div className="cert cert-JS">
                <a href={certJS}><img src={certJS}></img></a>
                <p>
                  {this.props.case.certificates.descrJS}
                  <br />
                  <span>
                    {this.props.case.certificates.school}
                    <br />
                    (08.2019 - 11.2019)
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}
